import type { FeedbackAnswerQuestionLong } from '@repo/types/questions/QuestionLong';

import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import {
  QuestionMarkedExplanationField,
  QuestionMarkedFormActions,
  QuestionMarkedPointsField,
  QuestionMarkedResponseCard,
  QuestionMarkedResponseHeader,
} from '@/components/features/quiz/question/question-marked/QuestionMarked';
import { Form } from '@/components/ui/form';

import type { QuestionMarkedLongFormProps } from '.';

export function QuestionMarkedLongForm(questionMarkedLongFormProps: QuestionMarkedLongFormProps) {
  const { marked, maxPoints, isOpen, onClose, onSubmit: _onSubmit } = questionMarkedLongFormProps;

  const form = useForm<FeedbackAnswerQuestionLong>({
    defaultValues: {
      points: 0,
      explanation: null,
      correct: true,
      marked: false,
    },
  });

  const onSubmit = (data: FeedbackAnswerQuestionLong) => {
    onClose();
    _onSubmit?.({ ...data, correct: true, marked: true });
  };

  useEffect(() => {
    if (isOpen && marked) {
      form.reset(marked);
    }
  }, [isOpen, marked, form]);

  return (
    <Form {...form}>
      <form className={'flex w-full flex-col gap-3 p-3'} onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <QuestionMarkedResponseCard>
          <QuestionMarkedResponseHeader>
            <div />
            <QuestionMarkedPointsField control={form.control} name="points" maxPoints={maxPoints} />
          </QuestionMarkedResponseHeader>
          <QuestionMarkedExplanationField control={form.control} name="explanation" />
        </QuestionMarkedResponseCard>
        <QuestionMarkedFormActions onClose={onClose} />
      </form>
    </Form>
  );
}
